import { render, staticRenderFns } from "./courseManageAudit.vue?vue&type=template&id=259a0b67&scoped=true"
import script from "./courseManageAudit.vue?vue&type=script&lang=js"
export * from "./courseManageAudit.vue?vue&type=script&lang=js"
import style0 from "./courseManageAudit.vue?vue&type=style&index=0&id=259a0b67&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259a0b67",
  null
  
)

export default component.exports